import "./style.scss"
import React, { useState } from "react";
import { Row, Col } from 'react-bootstrap';
// import { logoPlaceholder } from "../../../../assets/images";// "../../../../assets/images";
import { SlideDown } from 'react-slidedown'
import { ChevronUp, ChevronDown } from 'react-iconly';
import { createStyles, Theme, makeStyles } from "@material-ui/core/styles";
import { unknownBusinessLogo } from "assets/index";
import { FormattingUtils } from "utils/index";
import { SecondarySpanMedium } from "atoms/StyledComponents";
import { terciaryColor } from "designTokens/colors";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    link_hover: {
      "&:hover": {
        textDecoration: "underline !important",
        color: terciaryColor,
        cursor: "pointer"
      },
    },
  })
);


export interface BrokerSummaryCardProps {
  className?: any,
  brokerName?: string;
  numOffices?: number;
  totalClients?: number;
  totalCommissions?: number;
  totalPremiums?: number;
  companyInfo?: any;
  numContacts: number;
  imageUrl: string;
}

export const BrokerSummaryCard = (props: BrokerSummaryCardProps) => {

    const classes = useStyles();
    const [showBrokerInfo, setShowBrokerInfo] = useState(false);
    const handleCloseBrokerInfo = () => setShowBrokerInfo(false);
    const handleShowBrokerInfo = () => setShowBrokerInfo(true);

    // var getPieData = (obj) => ({
    //     labels: Object.keys(obj),
    //     datasets: [
    //       {
    //         data: Object.values(obj),
    //         backgroundColor: [
    //           '#2CDDC7',
    //           '#849AA9',
    //           '#59A7FF',
    //         ],
    //         borderWidth : 0
    //       },
    //     ],
    // });

    // // var totalComissions;
    // // var numOffices;
    // // var totalClients;
    // var planTypeChart;
    // var participantsChart;
    // var officeLocationChart;
    // var industryChart;
    // if (plans) {
    //     // totalComissions = plans.reduce((acc, curr) => acc + curr.total_commissions, 0);
    //     // numOffices = ListUtils.distinct(plans.map(p => p.broker_city + '-' + p.broker_state)).length;
    //     // totalClients = plans.length;
    //     // numContacts = null;

    //     var planTypeChartInputs = plans.reduce((a,b) => {
    //         if (!a[b.specific_plan_type]) {
    //             a[b.specific_plan_type] = 0;
    //         }
    //         a[b.specific_plan_type] += 1;
    //         return a;
    //     }, {});
    //     planTypeChart = getPieData(planTypeChartInputs);

    //     var participantsChartInputs = plans.reduce((a,b) => {
    //         if (!a[b.participant_ranges]) {
    //             a[b.participant_ranges] = 0;
    //         }
    //         a[b.participant_ranges] += 1;
    //         return a;
    //     }, {});
    //     participantsChart = getPieData(participantsChartInputs);

    //     var industryChartInputs = plans.reduce((a,b) => {
    //         if (!a[b.business_code_new_name]) {
    //             a[b.business_code_new_name] = 0;
    //         }
    //         a[b.business_code_new_name] += 1;
    //         return a;
    //     }, {});
    //     industryChart = getPieData(industryChartInputs);

    //     var officeLocationChartInputs = plans.reduce((a,b) => {
    //         var key = b.broker_state
    //         if (!a[key]) {
    //             a[key] = 0;
    //         }
    //         a[key] += 1;
    //         return a;
    //     }, {});
    //     officeLocationChart = getPieData(officeLocationChartInputs);
    // }

  return (
    <div className={`brocker-card ${props.className}`} style={{ padding: "25px" }}>
        <Row className="align-items-center">
            <Col sm={2}>
                <div className="card-img">
                    {/* <img src={logoPlaceholder} alt="" className="frame2" /> */}
                    {
                        props.companyInfo ?
                            <img
                            src={props.imageUrl}
                                onError={({ currentTarget }) => {
                                    currentTarget.onerror = () => {
                                        currentTarget.src = unknownBusinessLogo;
                                        currentTarget.onerror = null; // prevents further looping
                                    };
                                    currentTarget.src = `https://logo.clearbit.com/${props.companyInfo.website}`;
                                }}
                                style={{ width: "100px", borderRadius: "20px" }}
                            ></img> :
                            // <img src={logoPlaceholder} alt="" className="frame2" />
                            <img style={{ width: "100px", borderRadius: "20px" }} src={unknownBusinessLogo} alt="" className="frame2" />
                    }
                </div>
            </Col>
            <Col sm={10}>
            {/* <Col sm={10}> */}
                <div className="card-detail">
                    <div>
                        <h3 className="bd-name">{FormattingUtils.formatUpperCasing(props.brokerName)}</h3>
                        <span className="bd-address">{
                            props.companyInfo?.headquarters ? 
                                `HQ in ${props.companyInfo?.headquarters}` : 
                                null
                            }</span>
                        <div className="bd-actions">
                            {
                                props.companyInfo?.website ?
                                    <a href={`https://${props.companyInfo?.website}`} target="_blank" className={classes.link_hover} >Visit Website</a> :
                                    null
                            }
                            {
                                props.companyInfo?.linkedin_profile ?
                                    <a href={`https://${props.companyInfo?.linkedin_profile}`} target="_blank" className={classes.link_hover} >Visit LinkedIn</a> : 
                                    null
                            }
                        </div>
                    </div>
                    <div className="broker-stats">
                        <SecondarySpanMedium style={{ fontWeight: 700 }}>${FormattingUtils.formatNumberAbbrev(props.totalCommissions)} Commissions Reported</SecondarySpanMedium>
                        <span style={{ marginTop: "7px" }}>${FormattingUtils.formatNumberAbbrev(props.totalPremiums)} Carrier Premiums</span>
                        <span>{props.numOffices} Office Locations</span>
                        <span>{props.totalClients} Clients</span>
                        <span>{props.numContacts} Contacts</span>
                    </div>
                </div>
                <div style={{ paddingTop: "15px" }}>
                    {
                        showBrokerInfo ? 
                            <a onClick={handleCloseBrokerInfo} style={{ fontWeight: 300 }}>
                                See more
                            <ChevronUp set="light" style={{ marginLeft: "2px"}} size={20} />
                            </a> : 
                            <a onClick={handleShowBrokerInfo} style={{ fontWeight: 300 }}>
                                See more
                                <ChevronDown set="light" style={{ marginLeft: "2px"}} size={20} />
                            </a>
                    }
                </div>
            </Col>
        </Row>
        <Row>
            <Col sm={2} />
            <Col sm={10}>
                <div className="c-content">
                    <SlideDown className={'my-dropdown-slidedown'} style={{ overflow: "hidden" }}>
                        {showBrokerInfo ? 
                            <div style={{ marginTop: "20px" }}>
                                <p className="panel-desc" style={{ marginTop: "20px", whiteSpace: "pre-line" }}>
                                    {props.companyInfo?.description} 
                                </p>

                                {/* <h2 className="panel-title">
                                    Reported Commissions
                                </h2> */}

                                {/* <div className="">
                                    <Row>
                                        <Col md={6} xl={3}>
                                            <ChartBloc title="By Plan Type" data={planTypeChart} />
                                        </Col>
                                        <Col md={6} xl={3}>
                                            <ChartBloc title="By Participant Count" data={participantsChart} />
                                        </Col>
                                        <Col md={6} xl={3}>
                                            <ChartBloc title="By Industry" data={industryChart} />
                                        </Col>
                                        <Col md={6} xl={3}>
                                            <ChartBloc title="By Office Location" data={officeLocationChart} />
                                        </Col>
                                    </Row>
                                </div> */}
                            </div>
                        : null}
                    </SlideDown>
                </div>
            </Col>
        </Row>
    </div>
  );
}
